import script from "./FullscreenSlider.vue?vue&type=script&setup=true&lang=js"
export * from "./FullscreenSlider.vue?vue&type=script&setup=true&lang=js"

import "./FullscreenSlider.vue?vue&type=style&index=0&id=173f91d2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-173f91d2"]])

export default __exports__